module.exports = __webpack_public_path__ + "static/in-defense-of-a-liberal-education-8efb13271086c01ce9109c544f0d4376.jpg";